import type { ReactElement } from "react";
import { Route } from "react-router";
import ActoRoutes, { CustomerRouteSegments } from "@acto/taskpane/core/router/routes.config";
import { Layout } from "./Layout";
import { HomeNavLayout } from "./HomeNavLayout";
import { CustomerDetailsLayout } from "./CustomerDetailsLayout";
import { Home } from "./pages/Home";
import { AllCustomers } from "./pages/AllCustomers";
import { AllTodos } from "./pages/AllTodos";
import { Calendar } from "./pages/Calendar";
import { OpenRecapsPage } from "./pages/OpenRecapsPage";
import { CustomerRecapsPage } from "./pages/customer-recaps/CustomerRecapsPage.tsx";
import { CustomerOverview } from "./pages/customer-overview/CustomerOverview.tsx";
import { CustomerInfo } from "./pages/CustomerInfo.tsx";
import { CustomerAnalysis } from "./pages/analysis/CustomerAnalysis.tsx";
import { CorporateGroupAnalysis } from "./pages/analysis/CorporateGroupAnalysis.tsx";
import { AnalysisPage } from "./pages/analysis/AnalysisPage.tsx";
import { MeetingPrep } from "./pages/MeetingPrep";
import { MeetingPrepProfile } from "./pages/MeetingPrepProfile";
import { UserProfile } from "./pages/UserProfile";
import { TodosPage } from "./pages/TodosPage";
import { OrdersOverview } from "./pages/OrdersOverview";
import { OrderDetails } from "./pages/OrderDetails";
import { OffersOverview } from "./pages/OffersOverview";
import { OfferDetails } from "./pages/OfferDetails";
import { ChatPage } from "./pages/chat/ChatPage";

export function createFieldSalesTwoRoutes(): ReactElement {
  return (
    <Route element={<Layout />}>
      <Route element={<HomeNavLayout />}>
        <Route key="home" path={ActoRoutes.HOME} element={<Home />} />
        <Route key="customers" path={ActoRoutes.CUSTOMERS} element={<AllCustomers />} />
        <Route key="todos" path={ActoRoutes.TODOS_OVERVIEW} element={<AllTodos />} />
        <Route key="calendar" path={ActoRoutes.CALENDAR} element={<Calendar />} />
        <Route key="user-profile" path={ActoRoutes.USER_PROFILE} element={<UserProfile />} />
      </Route>
      <Route key="open-recaps" path={ActoRoutes.OPEN_RECAPS} element={<OpenRecapsPage />} />
      <Route key="customer-recaps" path={ActoRoutes.CUSTOMER_RECAPS} element={<CustomerRecapsPage />} />
      <Route path={ActoRoutes.CUSTOMER_DETAILS} element={<CustomerDetailsLayout />}>
        <Route index element={<CustomerOverview />} />
        <Route path={CustomerRouteSegments.INFO} element={<CustomerInfo />} />
        <Route path={CustomerRouteSegments.ANALYSIS} element={<CustomerAnalysis />} />
        <Route path={CustomerRouteSegments.GROUP} element={<CorporateGroupAnalysis />} />
        <Route path={CustomerRouteSegments.MEETING_PREP} element={<MeetingPrep />} />
        <Route path={CustomerRouteSegments.MEETING_PREP_PROFILE} element={<MeetingPrepProfile />} />
        <Route path={CustomerRouteSegments.TODOS} element={<TodosPage />} />
        <Route path={CustomerRouteSegments.ORDERS} element={<OrdersOverview />} />
        <Route path={CustomerRouteSegments.ORDER_DETAILS} element={<OrderDetails />} />
        <Route path={CustomerRouteSegments.OFFERS} element={<OffersOverview />} />
        <Route path={CustomerRouteSegments.OFFER_DETAILS} element={<OfferDetails />} />
      </Route>
      <Route key="chat" path={ActoRoutes.CHAT} element={<ChatPage />} />
      <Route key="analysis" path={ActoRoutes.ANALYSIS} element={<AnalysisPage />} />
    </Route>
  );
}
